import React from "react";

const Section7 = ({url}) => {
  return (

    <section className="home-section-7">
        <div className="container">

            {/* Heading */}
            <div className="text-center section-header">
            <h2>
                Enterprise <span>Document Intelligence</span> <br /> in Three Simple Steps
            </h2>
            <p className="section-desc">
                No complex configuration. No lengthy onboarding. Just intelligent, secure document control from day one.
            </p>
            </div>

            <div className="row d-flex align-items-center justify-content-center">

            {/* Left Steps */}
            <div className="col-lg-6 col-xl-5 col-md-12 steps-col" data-aos="fade-right" data-aos-duration="1000">

                <div className="step-card">
                <div className="step-number"><img src={`${url}images/concord/section-7/1.png`} alt="" /></div>
                <div className="step-content">
                    <h5>Upload & Organize</h5>
                    <p>
                        Upload your documents, an AI document-sorted tool will immediately learn your organizational structure, classify content, and apply your policies.
                    </p>
                </div>
                </div>

                <div className="step-card">
                <div className="step-number"><img src={`${url}images/concord/section-7/2.png`} alt="" /></div>
                <div className="step-content">
                    <h5>AI-Driven Access Control</h5>
                    <p>
                    Role-based permissions enforced, contextual intelligence understands your organizational hierarchy and secure your sensitive information.
                    </p>
                </div>
                </div>

                <div className="step-card">
                <div className="step-number"><img src={`${url}images/concord/section-7/3.png`} alt="" /></div>
                <div className="step-content">
                    <h5>Query, Collaborate, Audit</h5>
                    <p>
                    Search documents in plain language, collaborate securely, and maintain a complete audit trail, giving you full control, visibility, and compliance.
                    </p>
                </div>
                </div>

            </div>

            {/* Right Video */}
            <div className="col-lg-6 col-xl-5 col-md-12 video-col" data-aos="fade-left" data-aos-duration="1000">
                <div className="video-wrapper">
                    <video
                    className="demo-video"
                    controls
                    poster={`${url}images/intelihire/sec-7/video-thumb.png`}
                    >
                    <source src={`${url}images/concord.mp4`} type="video/mp4" />
                        Your browser does not support the video tag.
                    </video>
                </div>
                <p className="watch-demo">Watch Demo</p>
            </div>

            </div>
        </div>
    </section>
  );
};

export default Section7;
